import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

function Navigation() {
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          🎰 로또운세
        </Link>
        <ul className="nav-menu">
          <li>
            <Link
              to="/"
              className={isActive('/') && location.pathname === '/' ? 'nav-link active' : 'nav-link'}
            >
              홈
            </Link>
          </li>
          <li>
            <Link
              to="/lotto"
              className={isActive('/lotto') ? 'nav-link active' : 'nav-link'}
            >
              로또
            </Link>
          </li>
          <li>
            <Link
              to="/fortune"
              className={isActive('/fortune') ? 'nav-link active' : 'nav-link'}
            >
              운세
            </Link>
          </li>
          <li>
            <Link
              to="/stats"
              className={isActive('/stats') ? 'nav-link active' : 'nav-link'}
            >
              통계
            </Link>
          </li>
          <li>
            <Link
              to="/blog"
              className={isActive('/blog') ? 'nav-link active' : 'nav-link'}
            >
              블로그
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
